import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'apps/backoffice/src/environments/environment';

@Component({
  standalone: true,
  template: `<div class="wrapper">
    <iframe
      width="600"
      height="285"
      src="https://datastudio.google.com/embed/reporting/74fe9e0c-5698-4801-a267-fb72da4dc50b/page/BE7gF"
      frameborder="0"
      style="border:0"
      allowfullscreen
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    ></iframe>
  </div>`,
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  title: string;
  sanitizer: DomSanitizer;
  src: SafeResourceUrl;

  constructor() {
    this.sanitizer = inject(DomSanitizer);
    this.title = 'DashBackoffice';
    this.src = this.sanitizer.bypassSecurityTrustResourceUrl(environment.dashboardURL);
  }
}
